import Vue from 'vue'
import App from '@/App'

import Editor from 'v-markdown-editor'

import '@/plugins/particles'
import '@/plugins/notifications'
import '@/plugins/viewer'

import '@/plugins/vuex'
import store from './store'

import '@/plugins/router'
import router from './router/index'

import '@/plugins/axios'
import '@/plugins/vuetify'

import '@/scss/main.styl'
import '@/assets/styles/css/markdown-normalize.scss'

import '@/mixins/api'
import '@/mixins/features'
import '@/mixins/helpers'
import '@/mixins/resize'

Vue.config.productionTip = false
Vue.use(Editor)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
